export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10846.d5c44fe9.jpg";